import React, { useCallback, useEffect, useState } from 'react';
import api from '../../../../utils/api';

const ComboFailureDashboard = () => {
  const [failures, setFailures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await api.get('/admin/deals/combo/failures?limit=100');
      setFailures(res.data?.data?.failures || []);
    } catch (e) {
      setError(e?.response?.data?.message || 'Failed to load combo failures');
      setFailures([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-xl font-bold text-slate-900">Combo failure dashboard</h2>
          <p className="text-sm text-slate-500 mt-1">
            Checkout and validation rejections for combo bundles (audit action: combo_validation_reject).
          </p>
        </div>
        <button
          type="button"
          onClick={load}
          className="rounded-lg border border-slate-300 px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
        >
          Refresh
        </button>
      </div>

      {error && (
        <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">{error}</div>
      )}

      {loading ? (
        <p className="text-sm text-slate-500">Loading…</p>
      ) : failures.length === 0 ? (
        <p className="text-sm text-slate-500 rounded-lg border border-slate-200 bg-white px-4 py-8 text-center">
          No combo validation failures recorded.
        </p>
      ) : (
        <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white">
          <table className="min-w-full text-sm">
            <thead className="bg-slate-50 text-left text-xs uppercase text-slate-500">
              <tr>
                <th className="px-4 py-3">When</th>
                <th className="px-4 py-3">Deal</th>
                <th className="px-4 py-3">Actor</th>
                <th className="px-4 py-3">Details</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {failures.map((row) => (
                <tr key={row._id} className="hover:bg-slate-50/80">
                  <td className="px-4 py-3 whitespace-nowrap text-slate-600">
                    {row.createdAt ? new Date(row.createdAt).toLocaleString() : '—'}
                  </td>
                  <td className="px-4 py-3 font-mono text-xs text-slate-800">
                    {String(row.entityId || '—')}
                  </td>
                  <td className="px-4 py-3 text-slate-700">
                    {row.actorId?.name || row.actorId?.email || '—'}
                  </td>
                  <td className="px-4 py-3 text-slate-600">
                    <pre className="text-xs whitespace-pre-wrap max-w-md">
                      {JSON.stringify(row.meta || {}, null, 2)}
                    </pre>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ComboFailureDashboard;
